import React, { useState, useEffect, useRef, useCallback } from "react";
import Header from "../../../Header.js";
import { ToastContainer } from "react-toastify";
import {
  BiArrowBack,
  BiPencil,
  BiTrash,
  BiPlus,
  BiX,
  BiCheck,
} from "react-icons/bi";
import useFetchGet from "../hooks/useFetchGet.js";
import useFetchPost from "../hooks/useFetchPost.js";
import DatePicker from "rsuite/DatePicker";
import "rsuite/CheckPicker/styles/index.css";
import "../../../assets/css/rsuite.css";
import moment from "moment";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";

import { useHistory, useParams, useLocation } from "react-router-dom";
import { getCookie } from "../customer/Utility.js";
import NotesPanel from "../leads/components/NotesPanel.js";
import DealDetailsForm from "../leads/components/DealDetailsForm.js";
import Accordion from "../leads/components/common/Accordion.js";
import DealsHeader from "../leads/components/DealsHeader.js";
import { Toaster } from "react-hot-toast";
import toast from "react-hot-toast";
import { apiRequest } from "../../../utils/utils.js";

const currentUnixTime = Date.now();

const dealStates = ["Warm", "Hot", "Cold"].map((item) => ({
  id: item,
  value: item,
}));

const DealDetails = () => {
  const { fetchData } = useFetchGet();
  const { fetchPostData } = useFetchPost();
  const location = useLocation();
  const { deal_uuid: dealUuid } = useParams();
  const [isEdit, setIsEdit] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [customerSearchValue, setCustomerSearchValue] = useState("");
  const [productData, setProductData] = useState([]);
  const [productsList, setProductsList] = useState([]);
  // const [newprodData, setNewProdData] = useState([])
  const [stateData, setStateData] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [stateLoading, setStateLoading] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const history = useHistory();

  //necessory
  const [inputValue, setInputValue] = useState({
    // customer_id: "",
    mautic_id: "",
    product: [],
    deal_name: "",
    deal_value: "",
    deal_state: "",
    deal_description: "",
    deal_status: true,
    deal_id: "",
    deal_owner: "",
    deal_pipeline: "",
    deal_stage: "",
    reason: "",
  });
  const [rows, setRows] = useState([
    {
      milestone_sl_no: 1,
      milestone_desc: "",
      milestone_amount: "",
      milestone_due: null,
      milestone_status: "Draft",
      isEditable: false,

    },
  ]);
  const [tepDates, setTepDates] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [isDisable, setIsDisable] = useState(false);
  const [leadDetails, setLeadsDetails] = useState({});
  const [customerDetails, setCustomerDetails] = useState({});
  const [error, setError] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    fetchUsersList();
  }, []);

  const timerRef = useRef(null);

  // Get mautic_id from query params
  const queryParams = new URLSearchParams(location.search);
  const customer_identifier = queryParams.get("mautic_id");

  // Handle query param mautic_id on mount
  useEffect(() => {
    if (customer_identifier) {
      setInputValue((prevInputValue) => ({
        ...prevInputValue,
        mautic_id: customer_identifier,
      }));
    }
    if (customer_identifier) {
      fetchLeadDetails();
    }
  }, [customer_identifier]);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      getCustomers(customerSearchValue);
    }, 1000);
  }, [customerSearchValue]);

  const getDealDetails = async () => {
    const requestBody = {
      deal_id: dealUuid,
    };
    let crmStagingUrl = process.env.REACT_APP_CRM + "/crm/deal-detail";
    let responseData;
    try {
      responseData = await fetchPostData(crmStagingUrl, requestBody, true);
      //console.log("Response:", responseData);
    } catch (error) {
      console.error("Error:", error);
    }
    if (responseData && responseData.code == 200) {
      const data = responseData.data;
      document.title = `Intranet | ${data.deal_name}`;

      fetchCustomerDetails(data.mautic_id);

      setLeadsDetails({
        deal_id: data.deal_id,
        deal_uuid: data.deal_uuid,
        // customer_id: data.customer_id,
        mautic_id: data.mautic_id,
        product: data.product,
        deal_name: data.deal_name,
        deal_value: data.deal_value,
        deal_state: data.deal_state,
        deal_description: data.deal_description,
        deal_status: data.deal_status,
        mautic_id: data.mautic_id,
        created_at: data.created_at,
        deal_owner: data.deal_owner,
        deal_pipeline: data.deal_pipeline,
        deal_stage: data.deal_stage,
        reason: data.reason,
      });
      setCustomerSearchValue(data.company_name);

      const formattedMilestones = data.milestones
        ? data.milestones.map((milestone) => ({
          milestone_id: milestone.milestone_id,
          milestone_uuid: milestone.milestone_uuid,
          milestone_sl_no: milestone.milestone_sl_no,
          milestone_desc: milestone.milestone_desc,
          milestone_amount: milestone.milestone_amount,
          milestone_due: new Date(milestone.milestone_due * 1000),
          milestone_status: milestone.milestone_status,
          //milestone_status_show:
          //currentUnixTime > milestone.milestone_due ? "Overdue" : milestone.milestone_status,
          milestone_status_temp: milestone.milestone_status,
          milestone_amount_temp: milestone.milestone_amount,
          isEditable: true,
          deal_uuid: data.deal_uuid,
        }))
        : [];

      setRows(formattedMilestones);
    } else {
      history.push("/deals/list");
    }
  };

  const fetchCustomerDetails = async (customer_identifier) => {
    //TODO: Get this from ENV
    const mauticURL = process.env.REACT_APP_CRM_ADMIN;

    let url = mauticURL;

    if (!isNaN(customer_identifier)) {
      url += "/api/crm/contact/id/" + customer_identifier;
    } else if (/\S+@\S+\.\S+/.test(customer_identifier)) {
      url += "/api/crm/contact/email/" + customer_identifier;
    } else {
      url += "/api/crm/contact/customer-id/" + customer_identifier;
    }

    const findresponse = await apiRequest(url, "POST", {
        
        },null, true);

    if (findresponse && findresponse.code === 200) {
      const data = findresponse.data;

      if (!data) return;

      const { customer_id, other_contacts = [] } = data;

      setCustomerDetails({
        ...data,
        appToken: customer_id,
        otherContacts: other_contacts,
      });
    } else {
      toast.error("Customer not found");
      history.push("/deals/list");
    }
  };

  const fetchLeadDetails = async () => {
    //TODO: Get this from ENV
    const mauticURL = process.env.REACT_APP_CRM_ADMIN;

    let url = mauticURL;

    if (!isNaN(customer_identifier)) {
      console.log("Fetching by Mautic ID");
      url += "/api/crm/contact/id/" + customer_identifier;
    } else if (/\S+@\S+\.\S+/.test(customer_identifier)) {
      console.log("Fetching by email");
      url += "/api/crm/contact/email/" + customer_identifier;
    } else {
      console.log("Fetching by customer identifier");
      url += "/api/crm/contact/customer-id/" + customer_identifier;
    }

    const response = await fetch(url, {
      method: "POST",
    });
    const findresponse = await response.json();

    if (findresponse && findresponse.code === 200) {
      const data = findresponse.data;

      if (!data) return;
      const { name, associated_products, other_contacts = [] } = data;
      // Set customer details
      setLeadsDetails({
        ...data,
      });
      setCustomerSearchValue(name);
      // setInputValue()
    }
  };

  const getCustomers = async (keyword) => {
    let retData = [];

    if (!keyword) {
      setCustomerLoading(false);
      setCustomerData([]);
      return;
    }

    if (keyword.trim().length < 1) {
      setCustomerLoading(false);
      setCustomerData([]);
      return;
    }

    setCustomerLoading(true);
    try {
      let responseData;

      if (keyword.trim().length >= 1) {
        responseData = await fetchData(
          `${process.env.REACT_APP_CRM_ADMIN}/api/crm/get-customer-list?keyword=${keyword}`,
        );
      } else {
        responseData = await fetchData(
          `${process.env.REACT_APP_CRM_ADMIN}/api/crm/get-customer-list`,
        );
      }

      if (responseData.success == true) {
        retData = await responseData.data;
        setCustomerLoading(false);
      } else {
        setCustomerLoading(false);
      }

      const filteredData = retData.map((item) => ({
        label: item.name,
        value: item.mautic_id,
      }));
      // console.log(filteredData, customerData, retData, responseData.data,  "filteredDatafilteredData")
      setCustomerData(filteredData);
    } catch (error) {
      setCustomerLoading(false);
      setCustomerData([]);
      console.error("Error:", error);
    }
  };

  const getProduct = async () => {
    try {
      //DLOa1fdPDY9LN7RYOIyBhMKb161NCSSq
      const responseProductData = await fetchData(
        `${process.env.REACT_APP_CRM}/crm/product/list`,
      );
      //console.log("ProductList", responseProductData);
      setProductData(responseProductData);
      if (responseProductData) {
        const redata = responseProductData.map(
          ({ product_name, product_key }) => ({
            id: product_key,
            value: product_name,
            product_key: product_key,
          }),
        );

        setProductsList(redata);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchUsersList = () => {
    fetch(`${process.env.REACT_APP_CRM}/user-list`, {
      method: "POST",
    })
      .then((resp) => {
        return resp.json();
      })
      .then((data) => {
        if (data.code == 200) {
          const userList = data.data;
          setUsersList(userList);
        }
      });
  };

  const getDealState = async () => {
    setStateLoading(true);
    try {
      const responseData = await fetchData(
        `${process.env.REACT_APP_CRM}/crm/get-deal-state-list`,
      );
      if (responseData.code == 200) {
        setStateData(responseData.data);
        setStateLoading(false);
      }
    } catch (error) {
      setStateLoading(false);
      console.error("Error:", error);
    }
  };

  // useEffect(() => {
  // 	getProducts();
  // }, [inputValue.customer_id]);

  useEffect(() => {
    getProduct();
    if (dealUuid) {
      getDealDetails();
      //getCustomers();
      getDealState();
      setIsDisable(true);
      setIsEdit(true);
      document.title = `Intranet | Edit Deal`;
    } else {
      document.title = "Intranet | Add Deal";
      //getCustomers();
      setIsDisable(false);
      setIsEdit(false);
    }
  }, [dealUuid]);

  // useEffect(() => {
  // 	if (inputValue) {
  // 		getCustomers(customerKeyword);
  // 	}
  // }, [customerKeyword]);

  const handleCutomerChange = (item) => {
    if (item && item.value == "") {
      setCustomerSearchValue("");
      setInputValue((prevInputValue) => ({
        ...prevInputValue,
        mautic_id: "",
      }));
      return;
    }
    setCustomerSearchValue(item.label);
    setInputValue((prevInputValue) => ({
      ...prevInputValue,
      mautic_id: item.value,
    }));
  };

  // const handleSelectChange = (name) => (value) => {
  //   if (name === "mautic_id") {
  //     setInputValue((prevInputValue) => ({
  //       ...prevInputValue,
  //       mautic_id: value.value,
  //     }));
  //   } else {
  //     setInputValue((prevInputValue) => ({
  //       ...prevInputValue,
  //       [name]: value,
  //     }));
  //   }

  //   let validationErrors = {};

  //   if (name == "product_key") {
  //     validationErrors.product_key = "";
  //     document
  //       .querySelector(".product-key")
  //       .querySelector(`.rs-picker-toggle`).style.borderColor = "";
  //   }
  //   if (name == "deal_state") {
  //     validationErrors.deal_state = "";
  //     document
  //       .querySelector(".deal-state")
  //       .querySelector(`.rs-picker-toggle`).style.borderColor = "";
  //   }
  //   setError(validationErrors);
  // };

  // const handleDealInputChange = (event) => {
  //   const { name, value } = event.target;
  //   let formattedValue = value;

  //   if (name === "deal_value") {
  //     // Prevent non-numeric characters except a single dot
  //     formattedValue = formattedValue.replace(/[^0-9.]/g, "");

  //     // Ensure only one dot is present
  //     const parts = formattedValue.split(".");
  //     if (parts.length > 2) {
  //       formattedValue = parts[0] + "." + parts.slice(1).join("");
  //     }

  //     // Restrict to two decimal places
  //     if (parts.length === 2 && parts[1].length > 2) {
  //       formattedValue = parts[0] + "." + parts[1].slice(0, 2);
  //     }

  //     // Prevent leading dot (convert ".5" → "0.5")
  //     if (formattedValue.startsWith(".")) {
  //       formattedValue = "0" + formattedValue;
  //     }
  //   }

  //   setInputValue((prevInputValue) => ({
  //     ...prevInputValue,
  //     [name]: formattedValue,
  //   }));

  //   let validationErrors = {};
  //   let totalMilestoneAmount;
  //   let hasError = false;

  //   if (name === "deal_value") {
  //     const updatedRows = [...rows];
  //     totalMilestoneAmount = updatedRows.reduce((sum, milestone) => {
  //       return sum + Number(milestone.milestone_amount);
  //     }, 0);

  //     if (Number(formattedValue) === 0 || formattedValue === "") {
  //       validationErrors.deal_value = "Enter Deal Value";
  //       document.querySelector(".deal-value").style.borderColor = "red";
  //       hasError = true;
  //     } else {
  //       validationErrors.deal_value = "";
  //       document.querySelector(".deal-value").style.borderColor = "";
  //     }
  //   }

  //   setError(validationErrors);

  //   // If any error exists, return early
  //   if (
  //     hasError ||
  //     Object.values(validationErrors).some((error) => error !== "")
  //   ) {
  //     return;
  //   }
  // };

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;

    let formattedValue = value;
    let hasError = false;

    const updatedRows = rows.map((row) => ({ ...row }));

    /* ---------------- FORMAT MILESTONE AMOUNT ---------------- */
    if (name === "milestone_amount") {
      formattedValue = formattedValue.replace(/[^0-9.]/g, "");

      const parts = formattedValue.split(".");
      if (parts.length > 2) {
        formattedValue = parts[0] + "." + parts.slice(1).join("");
      }

      if (parts.length === 2 && parts[1].length > 2) {
        formattedValue = parts[0] + "." + parts[1].slice(0, 2);
      }

      if (formattedValue.startsWith(".")) {
        formattedValue = "0" + formattedValue;
      }
    }

    updatedRows[index][name] = formattedValue;

    /* ---------------- STATUS CHANGE LOGIC ---------------- */
    if (name === "milestone_amount") {
      if (updatedRows[index].milestone_amount_temp === formattedValue) {
        updatedRows[index].milestone_status =
          updatedRows[index].milestone_status_temp;
      } else {
        updatedRows[index].milestone_status = "Draft";
      }
    }

    /* ---------------- VALIDATION ---------------- */
    if (name === "milestone_amount") {
      let totalMilestoneAmount = 0;

      for (let i = 0; i < updatedRows.length; i++) {
        totalMilestoneAmount += Number(updatedRows[i].milestone_amount || 0);
      }
      setInputValue((prevInputValue) => ({
        ...prevInputValue,
        deal_value: totalMilestoneAmount,
      }));

      if (formattedValue === "" || Number(formattedValue) === 0) {
        updatedRows[index].milestone_amount_error = "Enter Amount";
        hasError = true;
      } else {
        updatedRows[index].milestone_amount_error = "";
      }

      // if (
      // 	Number(inputValue.deal_value) >= 1 &&
      // 	totalMilestoneAmount !== Number(inputValue.deal_value)
      // ) {
      // 	updatedRows[index].milestone_amount_error =
      // 		"Total milestone amount must equal Deal Value";
      // 	hasError = true;
      // }

      if (
        Number(inputValue.deal_value) >= 1 &&
        totalMilestoneAmount === Number(inputValue.deal_value)
      ) {
        for (let i = 0; i < updatedRows.length; i++) {
          updatedRows[i].milestone_amount_error = "";
        }
        setError({ deal_value: "" });
      }
    }

    if (name === "milestone_desc") {
      if (!formattedValue.trim()) {
        updatedRows[index].milestone_desc_error = "Enter Description";
        hasError = true;
      } else if (formattedValue.trim().length > 500) {
        updatedRows[index].milestone_desc_error =
          "Description Exceeds 500 Characters.";
        hasError = true;
      } else {
        updatedRows[index].milestone_desc_error = "";
      }
    }

    if (name === "milestone_due") {
      if (!formattedValue) {
        updatedRows[index].milestone_due_error = "Select Due Date";
        hasError = true;
      } else {
        updatedRows[index].milestone_due_error = "";
      }
    }

    /* ---------------- FINAL STATE UPDATE ---------------- */
    setRows(updatedRows);

    if (hasError) {
      return;
    }
  };

  const changeDealStatus = (value, event) => {
    setInputValue((prevInputValue) => ({
      ...prevInputValue,
      ["deal_status"]: value, // Update inputValue with the selected values
    }));
  };
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        milestone_sl_no: rows.length + 1,
        milestone_desc: "",
        milestone_amount: "",
        milestone_due: null,
        milestone_status: "Draft",
      },
    ]);
  };
  const handleChangeDate = (index, name) => (value) => {
    //console.log(value);
    // console.log(new Date("2023-02-22"));
    if (!value) {
      setRows((prevRows) =>
        prevRows.map((row, rowIndex) => {
          if (rowIndex === index) {
            return { ...row, [name]: "" };
          }
          return row;
        }),
      );
      setTepDates((prevTepDates) => ({ ...prevTepDates, [index]: "" }));
    } else {
      const formattedDates = moment(value).format("YYYY-MM-DD");
      setRows((prevRows) =>
        prevRows.map((row, rowIndex) => {
          if (rowIndex === index) {
            // Clear validation error and update the date
            return { ...row, [name]: formattedDates, milestone_due_error: "" };
          }
          return row;
        }),
      );
      setTepDates((prevTepDates) => ({ ...prevTepDates, [index]: value }));
      document
        .querySelector(`.milestone-due-${index}`)
        .querySelector('div[name="milestone_due"]').style.borderColor = "";
    }
  };
  const handleRemoveRow = async (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
    const res = await handleSubmit(updatedRows);
    if (res) {
      setRows(updatedRows);
    }
  };
  const editHandler = (index) => {
    setRows((prevRows) =>
      prevRows.map((row, rowIndex) => {
        if (rowIndex === index) {
          return { ...row, isEditable: false }; //milestone_status: "Due",
        }
        return row;
      }),
    );
  };
  const saveEditHandler = async (index) => {
    const res = await handleSubmit();
    if (res) {
      setRows((prevRows) =>
        prevRows.map((row, rowIndex) => {
          if (rowIndex === index) {
            return { ...row, isEditable: true };
          }
          return row;
        }),
      );
    }
  };
  const cancelEditHandler = (index) => {
    setRows((prevRows) =>
      prevRows.map((row, rowIndex) => {
        if (rowIndex === index) {
          return { ...row, isEditable: true };
        }
        return row;
      }),
    );
  };
  const handleCancel = () => {
    // Add your cancel logic here
    //console.log("Cancel button clicked!");
    window.parent.location = "/deals/list"; //window.parent.location.href;
  };

  function decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }

  function decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }

  const handleSubmit = async (milestoneData = null) => {
    const muviUserUuid = getCookie("muvi_useruuid");

    let mrows = rows;
    if (milestoneData) {
      mrows = milestoneData;
    }

    let validationErrors = {};
    let hasError = false;

    /* ---------------- DEAL VALIDATION ---------------- */

    if (!inputValue.mautic_id) {
      validationErrors.mautic_id = "Select Contact Name";
      hasError = true;
    }

    if (!inputValue.product || inputValue.product.length === 0) {
      validationErrors.product_key = "Select Product Name";
      hasError = true;
    }
    if (!inputValue.deal_description || !inputValue.deal_description.trim()) {
      validationErrors.deal_description = "Enter Deal Description";
      hasError = true;
    }

    if (!inputValue.deal_name || !inputValue.deal_name.trim()) {
      validationErrors.deal_name = "Enter Deal Name";
      hasError = true;
    } else if (inputValue.deal_name.length > 100) {
      validationErrors.deal_name = "Deal Name Exceeds 100 Characters.";
      hasError = true;
    }

    if (!inputValue.deal_value || Number(inputValue.deal_value) <= 0) {
      validationErrors.deal_value = "Enter Deal Value";
      hasError = true;
    } else {
      var totalMilestoneAmount = 0;

      for (let i = 0; i < mrows.length; i++) {
        totalMilestoneAmount += Number(mrows[i].milestone_amount || 0);
      }

      // if (totalMilestoneAmount !== Number(inputValue.deal_value)) {
      //   validationErrors.deal_value =
      //     "The Amount should be equal to the total Milestone Value.";
      //   hasError = true;
      // }
    }

    if (!inputValue.deal_state || !inputValue.deal_state.trim()) {
      validationErrors.deal_state = "Select Deal State";
      hasError = true;
    }
    if (!inputValue.deal_pipeline || !inputValue.deal_pipeline.trim()) {
			validationErrors.deal_pipeline = "Select Deal Pipeline";
			hasError = true;
		}


		if (!inputValue.deal_owner || !inputValue.deal_owner.trim()) {
			validationErrors.deal_owner = "Select Deal Owner";
			hasError = true;
		}
		if (!inputValue.deal_stage || !inputValue.deal_stage.trim()) {
			validationErrors.deal_stage = "Select Deal Stage";
			hasError = true;
		}

    /* ---------------- MILESTONE VALIDATION ---------------- */

    if (!mrows || mrows.length === 0) {
      validationErrors.milestone = "You need to add at least one milestone.";
      hasError = true;
    }

    const updatedRows = mrows.map((row) => ({
      ...row,
      milestone_desc_error: "",
      milestone_amount_error: "",
      milestone_due_error: "",
    }));

    for (let i = 0; i < updatedRows.length; i++) {
      const row = updatedRows[i];

      if (!row.milestone_desc || !row.milestone_desc.trim()) {
        row.milestone_desc_error = "Enter Description";
        validationErrors[`milestone_desc_${i}`] = "Enter Description";
        hasError = true;
      } else if (row.milestone_desc.length > 500) {
        row.milestone_desc_error = "Description Exceeds 500 Characters.";
        validationErrors[`milestone_desc_${i}`] =
          "Description Exceeds 500 Characters.";
        hasError = true;
      }

      if (
        !row.milestone_amount ||
        isNaN(row.milestone_amount) ||
        Number(row.milestone_amount) <= 0
      ) {
        row.milestone_amount_error = "Enter a valid Amount";
        validationErrors[`milestone_amount_${i}`] = "Enter a valid Amount";
        hasError = true;
      }

      if (!row.milestone_due) {
        row.milestone_due_error = "Select Due Date";
        validationErrors[`milestone_due_${i}`] = "Select Due Date";
        hasError = true;
      } else if (
        !moment(row.milestone_due, "YYYY-MM-DD", true).isValid() &&
        !moment(row.milestone_due).isValid()
      ) {
        row.milestone_due_error = "Select a valid Due Date";
        validationErrors[`milestone_due_${i}`] = "Select a valid Due Date";
        hasError = true;
      }
    }

    setRows(updatedRows);
    setError(validationErrors);
    console.log(validationErrors, "validationErrors");
    if (hasError) {
      return false;
    }
    setInputValue((prevInputValue) => ({
      ...prevInputValue,
      deal_value: totalMilestoneAmount,
    }));
    /* ---------------- PREPARE PAYLOAD ---------------- */

    setIsSaving(true);

    const formattedRows = updatedRows.map((item) => ({
      ...item,
      milestone_due: new Date(item.milestone_due).toLocaleDateString("en-CA"),
    }));

    const requestBody = {
      ...inputValue,
      milestone: formattedRows,
      user_uuid: muviUserUuid,
      mautic_id: inputValue.mautic_id,
      deal_uuid: leadDetails.deal_uuid,
      deal_value: totalMilestoneAmount,
      deal_id: leadDetails.deal_id,
    };

    let crmStagingUrl = process.env.REACT_APP_CRM + "/crm/store-deal-data";

    let responseData;
    try {
      responseData = await fetchPostData(crmStagingUrl, requestBody, true);
    } catch (error) {
      console.error("Error:", error);
      setIsSaving(false);
      return;
    }

    if (responseData && responseData.code === 200) {
      setIsSaving(false);
      toast.success(responseData.message);

      setIsEditing(false);
      return true;
    } else {
      setIsSaving(false);
      toast.error(responseData.message);
    }
  };

  const backHandler = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.replace("/deals/list");
    }
  };

  function convertUnixTimeStampToDate(unixTimestamp) {
    if (unixTimestamp) {
      const date = new Date(unixTimestamp).toLocaleDateString("en-CA");
      return date;
    }
  }
  return (
    <div className="crm-leads-details">
      <Header
        brecum_name="Deals"
        brecum_page={isEdit ? "Edit Deal" : "Add Deal"}
      />
      <Toaster
        toastOptions={{
          duration: 3000,
          position: "bottom-left",
        }}
      />

      <div
        class="right_col lead-account deals-details"
        style={{ paddingTop: "50px" }}
      >
        {/* customer details */}
        <div class="customer-details-area v2 notes crm">
          <div class="product-tab details-page p-0">
            <div
              class="h-full w-full d-flex gap-8"
              style={{ overflow: "hidden" }}
            >
              <div class="col-lg-4 col-md-12 p-8 card scrollable scrollable-y">
                <div class="flex-col gap-8">
                  <DealsHeader
                    customerDetails={customerDetails || {}}
                    productsList={productsList || []}
                    // currentUser={currentUser || {}}
                    refreshCustomerDetails={fetchCustomerDetails}
                    ismuvi5={false}
                    createdDate={leadDetails.created_at}
                  />
                  <div>
                    <DealDetailsForm
                      dealDetails={leadDetails}
                      productsList={productsList}
                      dealStates={dealStates}
                      customerSearchValue={customerSearchValue}
                      customerData={customerData}
                      setCustomerSearchValue={setCustomerSearchValue}
                      handleCutomerChange={handleCutomerChange}
                      customerLoading={customerLoading}
                      handleSubmit={handleSubmit}
                      setFormData={setInputValue}
                      formData={inputValue}
                      errors={error}
                      setErrors={setError}
                      setIsEditing={setIsEditing}
                      isEditing={isEditing}
                      usersList={Object.values(usersList)
                        .filter(user => user.is_active === 1)
                        .map(user => ({
                          value: user.name,
                          id: user.user_uuid
                        }))}
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-lg-8 col-md-12 p-0 h-full"
                style={{ overflow: "hidden" }}
              >
                <div
                  class="w-full nav-tabs-container"
                  style={{ flexShrink: 0 }}
                >
                  <button
                    onClick={backHandler}
                    className="back-toggle-btn"
                    style={{ zIndex: 999, right: "15px", top: "0px" }}
                  >
                    <span
                      style={{
                        fontSize: "18px",
                        lineHeight: "20px",
                        color: "rgb(122, 122, 122)",
                      }}
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 24 24"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M21 11H6.414l5.293-5.293-1.414-1.414L2.586 12l7.707 7.707 1.414-1.414L6.414 13H21z"></path>
                      </svg>
                    </span>
                  </button>
                </div>
                <div class="tab-content p-8 scrollable scrollable-y pt-0">
                  <div
                    className={`tab-pane active`}
                    id="overview"
                    role="tabpanel"
                  >
                    <div role="tabpanel" class="tab-pane active" id="overview">
                      <div className="flex-col gap-12">
                        <Accordion
                          header={"Payment Schedule"}
                          targetID={`paymentScheduleAccordion`}
                        >
                          <div className="containerfull mt20">
                            {error && (
                              <div className="text-danger">
                                {error.milestone_amount_total_error}
                              </div>
                            )}
                            <div className="table-wrap table-milestone">
                              <table
                                className="deal-table"
                                style={{
                                  tableLayout: "fixed",
                                  borderCollapse: "separate",
                                  borderSpacing: "0 10px",
                                  width: "100%",
                                  minWidth: 0,
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th style={styleObj.intra_col_7}>
                                      Milestone
                                    </th>
                                    <th style={styleObj.intra_col_15}>
                                      Description
                                    </th>
                                    <th style={styleObj.intra_col_15}>
                                      Amount ($)
                                    </th>
                                    <th style={styleObj.intra_col_10}>
                                      Due Date
                                    </th>
                                    <th style={styleObj.intra_col_10}>
                                      Payment Status
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {rows.map((row, index) => (
                                    <tr key={row.milestone_sl_no}>
                                      <td style={{ borderRight: "none" }}>
                                        {index + 1}
                                      </td>
                                      <td
                                        style={{
                                          borderRight: "none",
                                          borderLeft: "none",
                                        }}
                                      >
                                        <input
                                          type="text"
                                          className={`form-control milestone-desc-${index}`}
                                          id="feature"
                                          autoComplete="off"
                                          placeholder="Enter Description"
                                          name="milestone_desc"
                                          value={row.milestone_desc}
                                          onChange={(event) =>
                                            handleInputChange(index, event)
                                          }
                                          disabled={row.isEditable && true}
                                        />
                                        {row && (
                                          <div className="text-danger">
                                            {row.milestone_desc_error}
                                          </div>
                                        )}
                                      </td>
                                      <td
                                        style={{
                                          borderRight: "none",
                                          borderLeft: "none",
                                        }}
                                      >
                                        <input
                                          type="text"
                                          className={`form-control milestone-amount-${index}`}
                                          id="feature"
                                          autoComplete="off"
                                          placeholder="Enter Amount"
                                          name="milestone_amount"
                                          value={row.milestone_amount}
                                          onChange={(event) =>
                                            handleInputChange(index, event)
                                          }
                                          // onInput={(event) => {
                                          // 	event.target.value = event.target.value.replace(
                                          // 		/[^0-9]/g,
                                          // 		""
                                          // 	);
                                          // }}
                                          disabled={row.isEditable && true}
                                        />
                                        {row && (
                                          <div className="text-danger">
                                            {row.milestone_amount_error}
                                          </div>
                                        )}
                                      </td>

                                      <td
                                        style={{
                                          borderRight: "none",
                                          borderLeft: "none",
                                        }}
                                      >
                                        <div className="inputGroup">
                                          <DatePicker
                                            className={`milestone-due-${index}`}
                                            name="milestone_due"
                                            value={
                                              tepDates[index] ||
                                              (row.milestone_due &&
                                                row.milestone_due)
                                            }
                                            onChange={handleChangeDate(
                                              index,
                                              "milestone_due",
                                            )}
                                            disabled={row.isEditable && true}
                                            oneTap
                                          />
                                          {row && (
                                            <div className="text-danger">
                                              {row.milestone_due_error}
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          borderLeft: "none",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          {row.milestone_status ? (
                                            row.milestone_status === "Paid" ? (
                                              <p className="bagde-customer">
                                                Paid
                                              </p>
                                            ) : row.milestone_status ===
                                              "Due" ? (
                                              Date.now() > new Date(row.milestone_due).getTime()
                                                 ? (
                                                <p className="bagde-danger">
                                                  Overdue
                                                </p>
                                              ) : (
                                                <p className="bagde-warning">
                                                  Due
                                                </p>
                                              )
                                            ) : row.milestone_status ==
                                              "Lost" ? (
                                              <p className="bagde-internal">
                                                Lost
                                              </p>
                                            ) : (
                                              <p className="badge-yellow">
                                                Draft
                                              </p>
                                            )
                                          ) : (
                                            ""
                                          )}
                                          {/* <BiX style={{ fontSize: "18px", marginRight: "10px", float: "right" }} /> */}
                                          {isEdit &&
                                            row.isEditable &&
                                            (row.milestone_status == "Draft" ||
                                              row.milestone_status ==
                                              "Overdue" ||
                                              row.milestone_status ==
                                              "Due") && (
                                              <span style={{ float: "right" }}>
                                                <BiPencil
                                                  style={{
                                                    fontSize: "18px",
                                                    marginRight: "10px",
                                                  }}
                                                  onClick={() =>
                                                    editHandler(index)
                                                  }
                                                />
                                                <BiTrash
                                                  style={{
                                                    fontSize: "18px",
                                                    marginRight: "10px",
                                                  }}
                                                  onClick={() =>
                                                    handleRemoveRow(index)
                                                  }
                                                />
                                              </span>
                                            )}

                                          {isEdit &&
                                            !row.isEditable &&
                                            (row.milestone_status == "Draft" ||
                                              row.milestone_status ==
                                              "Overdue" ||
                                              row.milestone_status ==
                                              "Due") && (
                                              <span style={{ float: "right" }}>
                                                <BiCheck
                                                  style={{
                                                    fontSize: "18px",
                                                    marginRight: "10px",
                                                  }}
                                                  onClick={() => {
                                                    saveEditHandler(index);
                                                  }}
                                                />
                                                <BiX
                                                  style={{
                                                    fontSize: "18px",
                                                    marginRight: "10px",
                                                  }}
                                                  onClick={() =>
                                                    cancelEditHandler(index)
                                                  }
                                                />
                                              </span>
                                            )}

                                          {!isEdit && (
                                            <span style={{ float: "right" }}>
                                              <BiTrash
                                                style={{
                                                  fontSize: "18px",
                                                  marginRight: "10px",
                                                }}
                                                onClick={() =>
                                                  handleRemoveRow(index)
                                                }
                                              />
                                            </span>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                  {error && error.milestone ? (
                                    <tr>
                                      <td colSpan={5}>
                                        {error && (
                                          <div className="text-danger">
                                            {error.milestone}
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                </tbody>
                              </table>
                              <div
                                className="d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <div
                                  className="d-flex"
                                  style={{
                                    padding: "1rem .5rem",
                                    color: "#1675e0",
                                    fontSize: "11px",
                                    fontWeight: "500",
                                    cursor: "pointer",
                                    width: "fit-content",
                                  }}
                                  onClick={handleAddRow}
                                >
                                  <BiPlus style={{ fontSize: "16px" }} /> Add
                                  More Milestone
                                </div>
                              </div>
                            </div>
                          </div>
                        </Accordion>

                        <Accordion header={"Notes"} targetID={`notesAccordion`}>
                          <NotesPanel
                            customerTattleUUID={parseInt(dealUuid)}
                            mauticId={parseInt(dealUuid)}
                            usersList={usersList || []}
                            attribute_set_key="deals"
                            showFooterPanel={false}
                          />
                        </Accordion>
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styleObj = {
  informationTitle: {
    fontWeight: 500,
    fontSize: "14px",
    color: "#333",
    textTransform: "capitalize",
    fontFamily: "Poppins-Medium",
    padding: "10px 0",
  },
  intra_col_5: {
    width: "5%",
    wordWrap: "break-word",
    wordBreak: "break-all",
  },
  intra_col_7: {
    width: "7%",
    wordWrap: "break-word",
    wordBreak: "break-all",
  },
  intra_col_10: {
    width: "10%",
    wordWrap: "break-word",
    wordBreak: "break-all",
  },
  intra_col_15: {
    width: "15%",
    wordWrap: "break-word",
    wordBreak: "break-all",
  },
  intra_col_20: {
    width: "20%",
    wordWrap: "break-word",
    wordBreak: "break-all",
  },
  intra_col_2: {
    width: "2%",
  },
};
export default DealDetails;



// WEBPACK FOOTER //
// ./src/components/crm/deals/DealsDetails.js